import { render, staticRenderFns } from "./bulkSMS.vue?vue&type=template&id=5e64a0a8&scoped=true&"
import script from "./bulkSMS.vue?vue&type=script&lang=js&"
export * from "./bulkSMS.vue?vue&type=script&lang=js&"
import style0 from "./bulkSMS.vue?vue&type=style&index=0&id=5e64a0a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64a0a8",
  null
  
)

export default component.exports